<template>
  <div>
    <b-container>

      <failed-to-load
          v-if="error"
          name="Rino'er"
          :plural="false"
          :reload-function="initLoad"
      />
      <div v-else-if="ready">

        <b-row>
          <b-col>
            <h3 v-if="personnel.inserts"><span class="display-4">Rino'er</span> {{ personnel.first_name }} {{ personnel.inserts}} {{ personnel.surname }}</h3>
            <h3 v-else><span class="display-4">Rino'er</span> {{ personnel.first_name }} {{ personnel.surname }}</h3>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <small>
              <strong>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-calendar2-plus" viewBox="0 0 16 16">
                  <path
                      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/>
                  <path
                      d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM8 8a.5.5 0 0 1 .5.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5A.5.5 0 0 1 8 8z"/>
                </svg>
                Rino'er aangemaakt op
              </strong>
              {{ personnel.creation_date_time|dateTimeFormatter }}
            </small>
          </b-col>
          <b-col>
            <small>
              <strong>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-calendar2-check" viewBox="0 0 16 16">
                  <path
                      d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                  <path
                      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/>
                  <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>
                </svg>
                Voor het laatst aangepast op
              </strong>
              {{ personnel.last_changed_date_time|dateTimeFormatter }}
            </small>
          </b-col>
        </b-row>

        <hr/>

        <div>
          <b-nav align="center">
            <b-nav-item :to="{ name: 'EditPersonnel' }" exact exact-active-class="active">Algemene gegevens</b-nav-item>
            <b-nav-item :to="{ name: 'StatusAndTraining' }" exact exact-active-class="active">Status, Trainingen en Groepen</b-nav-item>
            <b-nav-item :to="{ name: 'ActivitiesOnPersonnel' }" exact exact-active-class="active">Activiteiten en statistieken
            </b-nav-item>
            <b-nav-item :to="{ name: 'DescriptionsAndCommentsOnPersonnel' }" exact exact-active-class="active">
              Omschrijving en
              opmerkingen
            </b-nav-item>
            <b-nav-item :to="{ name: 'evaluationsOnPersonnel' }" exact exact-active-class="active">
              Evaluaties
            </b-nav-item>
            <b-nav-item :to="{ name: 'StatementOfCostsOnPersonnel' }" exact exact-active-class="active">
              Declaraties
            </b-nav-item>
            <b-nav-item :to="{ name: 'editOverallAvailability' }" exact exact-active-class="active">
              Beschikbaarheid
            </b-nav-item>
          </b-nav>
        </div>

        <hr />

        <router-view :personnel="personnel" :personnelID="personnelID" :update="update"
                     :updateLocalPersonnelData="updateLocalPersonnelData"
                     activityLinkName="EditActivity"
                     :expandClient="true"
        />

      </div>

      <div v-else>
        <loadingComponents msg="Rino'er" :plural="false" />
      </div>

    </b-container>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import loadingComponents from "@/components/loadingComponents";
import _ from "lodash";
import failedToLoad from "@/components/failedToLoad";

export default {
  name: "EditPersonnel",
  data() {
    return {
      personnelID: Number,
      personnel: Object,

      ready: false,
      error: false,
    }
  },
  components: {
    loadingComponents,
    failedToLoad,
  },
  methods: {
    ...mapActions(["fetchPersonnel", "updatePersonnel"]),
    ...mapMutations(["destroyPersonnel"]),
    updateLocalPersonnelData() {
      this.personnel = _.cloneDeep(this.getPersonnel);
    },
    update() {
      this.updatePersonnel({
        id: this.personnelID,
        personnel: this.personnel
      }).then(() => {
        this.$bvToast.toast("Rino'er is succesvol aangepast", {
          title: 'Succes!',
          autoHideDelay: 1500,
          variant: 'success',
          appendToast: true
        });

        this.updateLocalPersonnelData();
      }).catch((err) => {
        if (err?.authorisationFailed === true) {
          this.$router.push({ name: 'Login', query: {'next': this.$route.fullPath}})
        }

        console.log(err);
        console.log(err.response);
      });
    },
    initLoad() {
      this.ready = false;
      this.error = false;

      this.fetchPersonnel(this.personnelID).then(() => {
        this.updateLocalPersonnelData();

        this.ready = true;
      }).catch((err) => {
        if (err?.authorisationFailed === true) {
          this.$router.push({ name: 'Login', query: {'next': this.$route.fullPath}})
        }

        console.log(err);
        console.log(err.response);

        this.error = true;
      });
    }
  },
  computed: {
    ...mapGetters(["getPersonnel"])
  },
  created() {
    this.personnelID = this.$route.params.personnelID;
    this.initLoad();
  },
  beforeRouteLeave(to, from, next) {
    this.destroyPersonnel();
    delete this.personnel;
    next();
  }
}
</script>

<style scoped>

</style>